import client from './client';

export interface Notification {
  id: string;
  type: string;
  title: string;
  body: string;
  metadata?: Record<string, any>;
  isRead: boolean;
  readAt?: string;
  createdAt: string;
}

export const notificationsApi = {
  list: (params?: { page?: number; limit?: number; unreadOnly?: boolean }) =>
    client.get<{ data: { notifications: Notification[]; total: number; unreadCount: number } }>('/notifications', { params }),

  unreadCount: () =>
    client.get<{ data: { count: number } }>('/notifications/unread-count'),

  markRead: (id: string) =>
    client.patch<{ data: Notification }>(`/notifications/${id}/read`),

  markAllRead: () =>
    client.patch('/notifications/read-all'),
};
